import { Image } from './Image';

export const AdvantagesMock: Image[] = [
  { src: '/assets/icons/best-time.svg', description: 'Best time' },
  { src: '/assets/icons/friendly-price.svg', description: 'Friendly price' },
  { src: '/assets/icons/high-quality.svg', description: 'High quality' },
  { src: '/assets/icons/happy-customers.svg', description: '5000+ happy customers' }
];
